
import { leftPad } from '@ms/utilities-strings/lib/index';

/**
 * @deprecated We no longer support IE 8, so this just returns `new Date(dateTime)`
 */
export function iso8601DateTimeToJsDate(dateTime: string): Date {
    return new Date(dateTime);
}

/**
 * @param dateString Date string
 * @param extended Selects extended format with date and time delimiters
 * @deprecated Use `date.toISOString()` instead. Though note that this method's return value
 * does NOT match the standard ISO string format, which ends with milliseconds, whereas this
 * ends with the time zone offset...
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString
 */
export function convertDateToISOString(dateString: string, extended: boolean = false): string {
    const date = new Date(dateString);

    // For more info on the time zone offset and its signage, see:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTimezoneOffset
    const isOffsetNegative: boolean = date.getTimezoneOffset() < 0;
    const year: string = date.getFullYear() + '';
    const month: string = leftPad((date.getMonth() + 1) + '', 2); // zero based month
    const day: string = leftPad(date.getDate() + '', 2);
    const hours: string = leftPad(date.getHours() + '', 2);
    const minutes: string = leftPad(date.getMinutes() + '', 2);
    const seconds: string = leftPad(date.getSeconds() + '', 2);
    const offsetHours: string = leftPad((isOffsetNegative ?
        (Math.ceil(date.getTimezoneOffset() / 60) + '').replace('-', '') :
        Math.floor(date.getTimezoneOffset() / 60) + ''), 2);
    const offsetMinutes: string = leftPad((date.getTimezoneOffset() % 60).toString().replace('-', ''), 2);
    const timezoneOffset: string = (isOffsetNegative ? '+' : '-') + offsetHours + offsetMinutes;
    if (extended) {
        return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + timezoneOffset;
    } else {
        return year + month + day + 'T' + hours + minutes + seconds + timezoneOffset;
    }
}
